@let requiredCustomControls = requiredCustomControls$ | async;
@if (editView || requiredCustomControls?.length) {
  <fieldset [class.edit-view]="editView && !requiredCustomControls?.length">
    <span class="title" translate>Information details</span>
    @if (editView && !requiredCustomControls?.length) {
      <p class="caption" translate>
        Any variables that will need to be filled in manually will appear here
      </p>
    }
    @if (requiredCustomControls?.length) {
      @if (requiredCustomControls.includes('Date and Time')) {
        <div class="form-group flex-100">
          <app-detail-input
            [control]="getterStaticCustoms && getterStaticCustoms['Date and Time']"
            [name]="'Date and Time'"
            [label]="'Date and Time'"
            [type]="'datetime-local'">
          </app-detail-input>
        </div>
      }
      @if (requiredCustomControls.includes('Departures')) {
        <div class="form-group flex-100">
          <app-detail-input
            [control]="getterStaticCustoms && getterStaticCustoms.Departures"
            [name]="'Departures'"
            [label]="'Departures'"
            [type]="'text'"
            [placeholder]="'12:30, 12:45 och 13:00'">
          </app-detail-input>
        </div>
      }
      @if (requiredCustomControls.includes('CustomFieldDescription')) {
        <div class="form-group flex-100">
          <app-detail-input
            [control]="getterStaticCustoms && getterStaticCustoms.CustomFieldDescription"
            [name]="'CustomFieldDescription'"
            [label]="'CustomFieldDescription'"
            [type]="'textarea'">
          </app-detail-input>
        </div>
      }
      @if (requiredCustomControls.includes('Amount of Minutes')) {
        <div class="form-group flex-100">
          <app-detail-input
            [control]="getterStaticCustoms && getterStaticCustoms['Amount of Minutes']"
            [name]="'Amount of Minutes'"
            [label]="'Amount of Minutes'"
            [type]="'text'">
          </app-detail-input>
        </div>
      }
      @if (requiredCustomControls.includes('Time')) {
        <div class="form-group flex-100">
          <app-detail-input
            [control]="getterStaticCustoms && getterStaticCustoms.Time"
            [name]="'Time'"
            [label]="'Time'"
            [type]="'time'">
          </app-detail-input>
        </div>
      }
      @for (control of requiredCustomControls; track currentTemplateId + '.' + control) {
        @if (![
          'Amount of Minutes',
          'Time',
          'CustomFieldDescription',
          'Departures',
          'Date and Time'].includes(control)) {
          <div class="form-group flex-100">
            <app-detail-input
              [control]="getterCustoms && getterCustoms[control]"
              [name]="control"
              [label]="control"
              [type]="'text'">
            </app-detail-input>
          </div>
        }
      }
    }
  </fieldset>
}